import { render, staticRenderFns } from "./ChangePaymentMethod.vue?vue&type=template&id=488152ed"
import script from "./ChangePaymentMethod.vue?vue&type=script&lang=js"
export * from "./ChangePaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488152ed')) {
      api.createRecord('488152ed', component.options)
    } else {
      api.reload('488152ed', component.options)
    }
    module.hot.accept("./ChangePaymentMethod.vue?vue&type=template&id=488152ed", function () {
      api.rerender('488152ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChangePaymentMethod.vue"
export default component.exports